export default __webpack_public_path__ + "static/thailand-fed85c4a91f0d2aa20e08941a2f7dc5f.svg";